import { render, staticRenderFns } from "./EditBlock.vue?vue&type=template&id=0786ca81&scoped=true&"
import script from "./EditBlock.vue?vue&type=script&lang=js&"
export * from "./EditBlock.vue?vue&type=script&lang=js&"
import style0 from "./EditBlock.vue?vue&type=style&index=0&id=0786ca81&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0786ca81",
  null
  
)

export default component.exports